module.exports = __webpack_public_path__ + "img/homebtn2.1760d63b.png";